// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1Z6GH","label":"Completed_label__2uNYT"};